import { Typography } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { TimeService, useDateTimeLocalizationInfo } from '@mews/framework';

export const ExceptionOpenHourInterval = () => {
    const localization = useDateTimeLocalizationInfo();
    const start = TimeService.toShortString(TimeService.parse('00:00:00'), localization);
    const end = TimeService.toShortString(TimeService.parse('23:59:59'), localization);

    return (
        <Typography textStyle="bodySmall" as="div">
            {start} {UnicodeEntity.Dash} {end}
        </Typography>
    );
};
